export const clientLinks = [
    {
        url: "https://www.disneystore.com/",
        name: "The Walt Disney Company"
    },
    {
        url: "https://www.cavenders.com/",
        name: "Cavender's"
    },
    {
        url: "https://www.thecompanystore.com/",
        name: "The Company Store"
    },
    {
        url: "https://www.pcrichard.com/",
        name: "PC Richard and Son"
    },
    {
        url: "https://www.zabars.com/",
        name: "Zabar's"
    }
]